import { WebLinkDistributionApi } from 'api/WebLinkDistributionApi';
import { backendApiClient } from 'container/backendApiClient';

export const webLinkDistributionApi = new WebLinkDistributionApi(backendApiClient);
